var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 1.002,
  clipPath: "url(#camera_svg__a)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M1.335 4.328c0-.915.79-1.657 1.763-1.657h3.819c.973 0 1.763.742 1.763 1.657v4.697c0 .916-.79 1.658-1.763 1.658h-3.82c-.973 0-1.762-.742-1.762-1.658z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.501 4.249 8.68 5.342v2.67L10.5 9.105c.668.4 1.517-.08 1.517-.859V5.107c0-.778-.85-1.259-1.517-.858Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "camera_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13.354v13.354H0z"
})))));
export default SvgCamera;